import { gql } from '@apollo/client'

import { checklistsClient } from '../apollo/api'
import { useQuery } from '../apollo/_helpers/useQuery'

const QUERY = gql`
  query Questions($checklistId: Int, $types: [String]) {
    questions(
      filter: { checklistIds: $checklistId, types: $types }
      limit: 999999999
      sort: { field: ORDINATION, type: ASC }
    ) {
      id
      name
      typeName
      reference
      parentReference
      category {
        id
        name
      }
    }
  }
`

export const useQuestionsFromApi = (checklistId, types, options) => {
  const { skip } = options || {}
  return useQuery(QUERY, {
    variables: { checklistId, origin, types },
    skip: !!skip || !checklistId,
    client: checklistsClient,
    fetchPolicy: 'cache-first'
  })
}

export const getQuestionsFromCache = (checklistId, types) => {
  const data = checklistsClient.readQuery({
    query: QUERY,
    variables: { checklistId, types }
  })

  return data?.questions || []
}

export const getQuestionsByType = (questions, selectedQuestion, questionType) => {
  return questions.filter(question => {
    if (!question.name) return false
    if (question.reference === selectedQuestion.reference) return false
    if (question.data?.multiple === true) return false
    return question.questionType?.name === questionType
  })
}

export const formatQuestionsByOrigin = (questions, dynamicFields, origin, description, group) => {
  if (!dynamicFields?.length) return []
  return questions
    .flatMap(question =>
      dynamicFields.map(dynamicField => {
        if (dynamicField.origin !== origin) return null
        return {
          id: `:reply:ref${question.reference}:field${dynamicField.id}`,
          name: `${question.name} - ${dynamicField.name}`,
          description,
          group
        }
      })
    )
    .filter(item => item !== null)
}

export const formatQuestionsByOrigins = (questions, dynamicFields, origins = [], description, group) => {
  if (!dynamicFields?.length) return []
  return questions
    .flatMap(question =>
      dynamicFields.map(dynamicField => {
        if (!origins.includes(dynamicField.origin)) return null
        return {
          id: `:reply:ref${question.reference}:field${dynamicField.id}`,
          name: `${question.name} - ${dynamicField.name}`,
          description,
          group
        }
      })
    )
    .filter(item => item !== null)
}

export const getCalculableQuestions = (questions, selectedQuestion, description, group) => {
  return questions
    .filter(question => {
      if (!question.name) return false
      if (question.reference === selectedQuestion.reference) return false
      return ['numeric', 'decimal', 'calc', 'float'].includes(question.questionType?.name)
    })
    .map(question => ({
      id: `:reply:ref${question.reference}`,
      name: question.name,
      description,
      group
    }))
}

export const findChildren = (nodes, predicate) => {
  for (const node of nodes) {
    if (predicate(node)) return node

    if (node.children) {
      let match = findChildren(node.children, predicate)
      if (match) return node
    }
  }
}
